module.exports = __webpack_public_path__ + "img/point.37a2ad8b.png";